import { useContext, useEffect, useState } from "react";
import { SysMessagesContext } from "../../../contexts/sys_messages/context";
import { usePerspective } from "../../../contexts/app/provider";
import { SysMessageLevel } from "../../../contexts/sys_messages/type";
import { RunNameComponent } from "./component";
import {
  Run,
  useSetMyRunNameMutation,
} from "../../../services/perspective_api/__generated__/perspective_server-types";

export const RunNameContainer = (props: { run: Run }) => {
  const { run } = props;
  const { addSystemMessage } = useContext(SysMessagesContext);
  const { perspectiveApiService } = usePerspective();

  const [name, setName] = useState<string>(run.name || "");

  useEffect(() => {
    setName(run.name || "");
  }, [run.name]);

  const [setMyRunName] = useSetMyRunNameMutation({
    client: perspectiveApiService.getClient(),
  });

  const saveName = () => {
    if (!name) {
      return;
    }

    setMyRunName({
      variables: {
        runSettings: {
          inputId: run.runSettings.inputId,
          workflowId: run.runSettings.workflowId,
          settingsNameAndVersion: run.runSettings.settingsNameAndVersion,
          runAttemptId: run.runSettings.runAttemptId,
        },
        name,
      },
      onError: (error) => {
        if (error?.message !== undefined) {
          addSystemMessage({
            level: SysMessageLevel.WARNING,
            message: error.message!,
          });
        }
      },
      onCompleted: () => {
        addSystemMessage({
          level: SysMessageLevel.SUCCESS,
          message: "Name updated",
        });
      },
    });
  };

  return <RunNameComponent name={name} setName={setName} saveName={saveName} />;
};
